import axios from "axios";

export const createFeedback = async (feedbackText, feedbackValue) =>
  await axios.post(`/api/feedback`, {
    feedbackText,
    feedbackValue,
  });
